import mixpanel from 'mixpanel-browser';

mixpanel.init("65fb070fa66b8d6b857ea69ee1fe43e0");

const env_check = process.env.NODE_ENV === 'production';

const actions = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id) => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
};

export default actions;
